import { Button, ArticleHeading2, useDeviceType } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { clsx as cx } from 'clsx';
import * as React from 'react';

import * as styles from './CalculatorForm.css';

interface ICalculatorLayoutProps {
  contentFooter: React.ReactNode;
  scrollableContent?: React.Ref<HTMLDivElement>;
  errorMessage?: string;
  loading?: boolean;
  disabled?: boolean;
  onSubmit?(event: React.FormEvent<HTMLFormElement>): void;
  children: React.ReactNode;
}

export const CalculatorForm: React.FC<ICalculatorLayoutProps> = ({
  children,
  contentFooter,
  scrollableContent,
  errorMessage,
  loading,
  disabled,
  onSubmit,
}) => {
  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';
  const buttonSize: TButtonSize = isPhone ? 'M' : 'XS';

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (loading || !onSubmit) {
      return;
    }

    onSubmit(event);
  };

  return (
    <form
      className={cx(styles['container'], styles[`container--${deviceType}`])}
      onSubmit={handleSubmit}
      data-testid="form"
    >
      <div className={styles['header']}>
        <ArticleHeading2>Какую квартиру хотите?</ArticleHeading2>
      </div>
      <div className={styles['content']}>
        <div ref={scrollableContent} className={styles['content-scrollable']}>
          {children}
          {errorMessage && <div className={styles['error-message']}>{errorMessage}</div>}
          {contentFooter && <div className={styles['content-footer']}>{contentFooter}</div>}
        </div>
      </div>
      <div className={styles['footer']}>
        <Button
          theme="fill_primary"
          size={buttonSize}
          type="submit"
          fullWidth={isPhone}
          loading={loading}
          disabled={disabled}
        >
          Рассчитать
        </Button>
      </div>
    </form>
  );
};
